import { createSlice } from '@reduxjs/toolkit';

const dialogsSlice = createSlice({
  name: 'dialogs',
  initialState: {
    createCustomer: false,
    addProduct: false,
    addComplaint: false,
    viewComplaint: false,
    updateComplaint: false,
    hideQrRun: false,
  },
  reducers: {
    openDialog: (state, action) => { 
      state[action.payload] = true;
    },
    closeDialog: (state, action) => { 
      state[action.payload] = false;
    },
  },
});

export const { openDialog, closeDialog } = dialogsSlice.actions;
export default dialogsSlice.reducer;